/**
 * Editor configuration for models managed from the admin area.
 * A model without an entry here gets the read-only list from CrudPage.
 */
const toOptions = (values) => values.map((v) => ({ value: v, label: v }));

export const SERVICE_CATEGORIES = [
  { value: 'fire', label: 'Fire fighting' },
  { value: 'security', label: 'Security & surveillance' },
  { value: 'audit', label: 'Safety audit & consultancy' },
  { value: 'training', label: 'Training' },
];

export const MODEL_EDITORS = {
  Service: {
    title: 'Services',
    columns: ['title', 'category', 'sort_order', 'is_published'],
    fields: [
      { name: 'title', label: 'Title', required: true },
      { name: 'slug', label: 'Short URL name', placeholder: 'fire-hydrant-system' },
      { name: 'category', label: 'Category', type: 'select', options: SERVICE_CATEGORIES, defaultValue: 'fire' },
      { name: 'summary', label: 'Summary', type: 'textarea' },
      { name: 'points', label: 'Key points (one per line)', type: 'textarea' },
      { name: 'image', label: 'Image path or URL', placeholder: '/images/services/example.webp' },
      { name: 'icon', label: 'Icon name', placeholder: 'flame, shield-check, cctv' },
      { name: 'sort_order', label: 'Display order', type: 'number', defaultValue: 0 },
      { name: 'is_published', label: 'Show on website', type: 'switch', defaultValue: true },
    ],
  },
  ClientLogo: {
    title: 'Client logos',
    columns: ['name', 'logo', 'sort_order', 'is_published'],
    fields: [
      { name: 'name', label: 'Client name', required: true },
      { name: 'logo', label: 'Logo path or URL', required: true, placeholder: '/images/clients/example.webp' },
      { name: 'sort_order', label: 'Display order', type: 'number', defaultValue: 0 },
      { name: 'is_published', label: 'Show on website', type: 'switch', defaultValue: true },
    ],
  },
  Testimonial: {
    title: 'Testimonials',
    columns: ['name', 'company', 'sort_order', 'is_published'],
    fields: [
      { name: 'name', label: 'Person name', required: true },
      { name: 'designation', label: 'Designation' },
      { name: 'company', label: 'Company' },
      { name: 'quote', label: 'Quote', type: 'textarea', required: true },
      { name: 'image', label: 'Letter / photo path (optional)', placeholder: '/images/certificates/letter-01.webp' },
      { name: 'sort_order', label: 'Display order', type: 'number', defaultValue: 0 },
      { name: 'is_published', label: 'Show on website', type: 'switch', defaultValue: true },
    ],
  },
  GalleryPhoto: {
    title: 'Gallery photos',
    columns: ['image', 'category', 'alt', 'is_published'],
    fields: [
      { name: 'image', label: 'Image path or URL', required: true, placeholder: '/images/gallery/example.webp' },
      { name: 'alt', label: 'Description (alt text)' },
      {
        name: 'category',
        label: 'Category',
        type: 'select',
        options: toOptions(['Installations', 'Training', 'Recognition']),
        defaultValue: 'Installations',
      },
      { name: 'sort_order', label: 'Display order', type: 'number', defaultValue: 0 },
      { name: 'is_published', label: 'Show on website', type: 'switch', defaultValue: true },
    ],
  },
  Enquiry: {
    title: 'Enquiries',
    canCreate: false,
    columns: ['name', 'phone', 'service_interest', 'status', 'created_at'],
    fields: [
      { name: 'name', label: 'Name', readOnly: true },
      { name: 'company', label: 'Company', readOnly: true },
      { name: 'phone', label: 'Phone', readOnly: true },
      { name: 'email', label: 'Email', readOnly: true },
      { name: 'service_interest', label: 'Service', readOnly: true },
      { name: 'location', label: 'Site location', readOnly: true },
      { name: 'message', label: 'Message', type: 'textarea', readOnly: true },
      { name: 'status', label: 'Status', type: 'select', options: toOptions(['new', 'contacted', 'quoted', 'won', 'closed']) },
    ],
  },
};
